<ng-container>
  <div class="hangfire-ecs-widget" *ngIf="hangfireECSServiceOverview">
    <h3>
      Hangfire ECS Task Info
      <i
        class="fa fa-power-off power-button"
        aria-hidden="true"
        (click)="onStartStopHangfireECSServiceClick()"
        [ngClass]="
          hangfireECSServiceOverview.length > 0 ? 'power-button-online' : 'power-button-offline'
        "
      ></i>
    </h3>
    <ul *ngIf="hangfireECSServiceOverview.length > 0">
      <li><strong>IP Address:</strong> {{ hangfireECSServiceOverview[0].ipAddress }}</li>
      <li><strong>Status:</strong> {{ hangfireECSServiceOverview[0].status }}</li>
      <li><strong>Desired Status:</strong> {{ hangfireECSServiceOverview[0].desiredStatus }}</li>
      <li><strong>Cluster Name:</strong> {{ hangfireECSServiceOverview[0].clusterName }}</li>
      <li><strong>Service Name:</strong> {{ hangfireECSServiceOverview[0].serviceName }}</li>
      <li>
        <strong>Task Definition ID:</strong> {{ hangfireECSServiceOverview[0].taskDefinitionId }}
      </li>
      <li *ngIf="hangfireECSServiceOverview[0].status == 'RUNNING'">
        <strong>Uptime:</strong> {{ trimFractionalSeconds(hangfireECSServiceOverview[0].uptime) }}
      </li>
    </ul>
    <p *ngIf="hangfireECSServiceOverview.length == 0">
      There are currently no Hangfire containers running. Please press the 'On' button to start the
      service. Please note that it may take a few minutes before Hangfire shows as being online.
    </p>
  </div>
</ng-container>
<ng-container *ngIf="!featureEnabled">
  <p class="align-center">This feature is not available on this environment.</p>
</ng-container>
